<template>
  <inv-strat-container ref="container"></inv-strat-container>
</template>

<script>
import InvStratContainer from '@/app/modules/toolkit/inv-strat/containers/inv-strat-container/inv-strat-container.vue';

export default {
  name: 'toolkit-inv-strat',
  components: {
    InvStratContainer,
  },
  mounted() {
    if (this.$route.params.step) {
      this.$refs.container.handleStepChange(parseInt(this.$route.params.step, 10));
    }
  },
};
</script>
